module.exports = fox._r("images/uploads-sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/uploads-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/uploads-sprite.png
// module id = 101
// module chunks = 2